import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { sendEmails } from '../helper/emailHelper';
import AddEmailConfirmation from '../helper/HTMLTemplate/AddEmailConfirmation';
import Cookies from 'universal-cookie';
import { Bounce, toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { transactionAction } from '../helper/chain-helper';
import { getHostContract, getHostHelperContract } from '../helper/contract-helper';
import { getSendAsEmails } from '../helper/settingsHelper';
import { CompleteLoader } from '../modals/common-alert';
import config from "../web3/web3Config.json";
import { encodeToHex } from '../helper/commonHelper';
import { getPublicKeyValue } from '../helper/web3helper';
import { reportError, toErrorString } from '../utils/errorLogger';

const AddEmailModal = ({ open, onClose, isVerify, verifyEmail }) => {
  const cookies = new Cookies();
  const dispatch = useDispatch();
  const refreshSettings = useSelector((state) => state.refreshSettings);

  const [email, setEmail] = useState('');
  const [isAlias, setIsAlias] = useState(true);
  const [showReplyTo, setShowReplyTo] = useState(false);
  const [replyTo, setReplyTo] = useState('');
  const [step, setStep] = useState(1);
  const [verificationSent, setVerificationSent] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [user] = useState(cookies.get("userObject"));
  const [sendLoader, setSendLoader] = useState(false);

  useEffect(() => {
    if (isVerify) {
      setEmail(verifyEmail)
      setVerificationSent(true);
      setStep(2);
    } else {
      setEmail('');
      setVerificationSent(false);
      setStep(1);
    }
  }, [isVerify]);

  if (!open) return null;

  const validateEmail = async (email) => {
    if (!email) {
      setEmailError('Email address is required');
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError('Please enter a valid email address');
      return false;
    }

    const contractMethods = getHostContract();
    const publicKey = await contractMethods.methods.getPublicKeyOfUser(email).call();
    if (!publicKey) {
      setEmailError('This email address does not exist in our platform.');
      return false;
    }

    // Duplicate email check
    const sendAsEmail = await getSendAsEmails();
    if (sendAsEmail && sendAsEmail.some(e => e.email?.toLowerCase() === email.toLowerCase())) {
      setEmailError('This email address is already added.');
      return false;
    }
    setEmailError('');
    return true;
  };

  const nextStep = async () => {
    if (await validateEmail(email)) setStep(2);
  };

  const handleSendVerification = async () => {
    try {
      setSendLoader(true);
      const sendAsEmail = await getSendAsEmails();
      const existingIdx = sendAsEmail.findIndex(e => e.email?.toLowerCase() === email.toLowerCase());
      if (existingIdx !== -1) {
        // Email exists
        if (sendAsEmail[existingIdx].verify === 'false') {
          // Allow re-verification for unverified email
          let defaultEncryptedMessage = "MSG";
          let recipient = email;
          let subject = `Dmail Confirmation - Send Mail as ${email}`;
          const encodeValue = encodeToHex(user.name);
          let url = config.DMAIL_URL + `confirm-send-as?token=${encodeValue}`;
          const messages = AddEmailConfirmation({ email: user.name, aliasesEmail: email, url })
          const result = await sendEmails([recipient], [], [], subject, messages, true, defaultEncryptedMessage, null);
          if (result) {
            // Only update verify field for this email
            const newEmails = sendAsEmail.map((e, i) => i === existingIdx ? { ...e, verify: 'false' } : e);
            const options = [];
            newEmails.forEach((email, index) => {
              options.push(
                { key: `email~${index + 1}`, value: email.email },
                { key: `isDefault~${index + 1}`, value: email.isDefault },
                { key: `verify~${index + 1}`, value: email.verify }
              );
            });
            const helperContract = getHostHelperContract();
            const functionParams = [user.name, 'sendAsEmail', options];
            const hash = await transactionAction(helperContract, "updateSettings", functionParams, '', 'helper');
            if (hash) {
              setVerificationSent(true);
              setStep(2);
              dispatch({ type: "REFRESH_SETTINGS", payload: !refreshSettings });
              toast.success("Verification email re-sent.", {
                position: "top-center",
                transition: Bounce,
              });
            } else {
              toast.error("Something went wrong.", {
                position: "top-center",
                transition: Bounce,
              });
            }
          }
        } else {
          setEmailError('This email address is already added and verified.');
          setSendLoader(false);
          return;
        }
      } else {
        // New email logic
        if (await validateEmail(email)) {
          let defaultEncryptedMessage = "MSG";
          let recipient = email;
          let subject = `Dmail Confirmation - Send Mail as ${email}`;
          const encodeValue = encodeToHex(user.name);
          let url = config.DMAIL_URL + `confirm-send-as?token=${encodeValue}`;
          const messages = AddEmailConfirmation({ email: user.name, aliasesEmail: email, url })
          const result = await sendEmails([recipient], [], [], subject, messages, true, defaultEncryptedMessage, null);
          if (result) {
            const options = [];
            sendAsEmail.forEach((email, index) => {
              options.push(
                { key: `email~${index + 1}`, value: email.email },
                { key: `isDefault~${index + 1}`, value: email.isDefault },
                { key: `verify~${index + 1}`, value: email.verify }
              );
            });
            options.push(
              { key: `email~${sendAsEmail.length + 1}`, value: email },
              { key: `isDefault~${sendAsEmail.length + 1}`, value: "false" },
              { key: `verify~${sendAsEmail.length + 1}`, value: "false" }
            );
            const helperContract = getHostHelperContract();
            const functionParams = [user.name, 'sendAsEmail', options];
            const hash = await transactionAction(helperContract, "updateSettings", functionParams, '', 'helper');
            if (hash) {
              setVerificationSent(true);
              setStep(2);
              dispatch({ type: "REFRESH_SETTINGS", payload: !refreshSettings });
              toast.success("Successfully sended.", {
                position: "top-center",
                transition: Bounce,
              });
            } else {
              toast.error("Something went wrong.", {
                position: "top-center",
                transition: Bounce,
              });
            }
          }
        }
      }
    } catch (error) {
      const errorStr = toErrorString(error || error.message);
      const userName = localStorage.getItem('UserName');
      reportError({
        endpoint: '-',
        message: `FileName: AddEmailModal.js, Fun: handleSendVerification, ${String(error.message || 'Unhandled error')}`,
        error: errorStr,
        userName: userName || '',
      });
      console.log("error", error)
    } finally {
      setSendLoader(false);
    }
  };

  const renderStep1 = () => (
    <>
      <div className="modal-glass p-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-semibold m-0">Add another email address</h5>
          <button className="btn-close" onClick={onClose}></button>
        </div>
        <div className="form-floating mb-3">
          <input
            type="email"
            className={`form-control ${emailError ? 'is-invalid' : ''}`}
            id="floatingEmail"
            placeholder="name@example.com"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError('')
            }}
          />
          <label htmlFor="floatingEmail">Email address</label>
          {emailError && <div className="invalid-feedback">{emailError}</div>}
        </div>

        {/* <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            checked={isAlias}
            onChange={(e) => setIsAlias(e.target.checked)}
            id="aliasCheckbox"
          />
          <label className="form-check-label" htmlFor="aliasCheckbox">
            Treat as an alias{' '}
            <span
              className="text-decoration-underline text-primary"
              style={{ cursor: 'pointer', fontSize: '12px' }}
              onClick={() => window.open('https://support.google.com/mail/answer/1710336', '_blank')}
            >
              Learn more
            </span>
          </label>
        </div> */}

        {/* <div className="mb-3">
          <span
            className="text-primary text-decoration-underline"
            style={{ fontSize: '12px', cursor: 'pointer' }}
            onClick={() => setShowReplyTo(!showReplyTo)}
          >
            Specify a different "reply-to" address (optional)
          </span>
          {showReplyTo && (
            <input
              type="email"
              className="form-control mt-2"
              placeholder="Reply-to address"
              value={replyTo}
              onChange={(e) => setReplyTo(e.target.value)}
            />
          )}
        </div> */}

        <div className="d-flex justify-content-end gap-2">
          <button className="btn btn-outline-secondary" onClick={onClose}>Cancel</button>
          <button
            className="btn gradient-btn"
            onClick={nextStep}
            disabled={!email || emailError}
          >
            Next Step &raquo;
          </button>
        </div>
      </div>
    </>
  );

  const renderStep2 = () => (
    <>
      <div className="modal-glass p-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-semibold m-0">Verify your email address</h5>
          <button className="btn-close" onClick={() => {
            setEmail('');
            setStep(1);
            setVerificationSent(false);
            onClose()
          }}></button>
        </div>

        <p className="mb-2">
          Before you can send mail as <strong>{email}</strong>, we need to verify that you own this email address.
        </p>
        <p>
          {verificationSent ? (
            <>
              An email with a confirmation link was sent to <strong>{email}</strong>.{' '}
              <button
                className="btn btn-link p-0 text-decoration-underline"
                onClick={handleSendVerification}
              >
                Resend email
              </button>
              <br />
              Click the link in the confirmation email to verify your address.
              <br />
              <button
                type="button"
                className="btn btn-link w-100"
                onClick={() => {
                  setEmail('');
                  setStep(1);
                  setVerificationSent(false);
                  onClose()
                }}
              >
                Close window
              </button>
            </>
          ) : (
            <>
              Click <strong>Send Verification</strong> and we'll email {email} with verification instructions.
            </>
          )}
        </p>

        {!verificationSent && (
          <div className="d-flex justify-content-end gap-2">
            <button className="btn btn-outline-secondary" onClick={() => {
              setEmail('');
              setStep(1);
              setVerificationSent(false);
              onClose()
            }}>Cancel</button>
            <button
              className="btn btn-primary gradient-btn"
              onClick={handleSendVerification}
              disabled={!email || emailError}
            >
              Send Verification
            </button>
          </div>
        )}
      </div>
    </>
  );

  return (
    <>
      <CompleteLoader isOpen={sendLoader} text={"Processing..."} />
      <div className="modal show d-block bg-black-translucent">
        <div className="modal-dialog">
          <div className="modal-content border-0 shadow-lg">{step === 1 ? renderStep1() : renderStep2()}</div>
        </div>
      </div>
    </>
  );
};

export default AddEmailModal;
